module.exports = __webpack_public_path__ + "static/media/mnc-companies.c48626b8.jpg";